import { IAddressModel } from './models/models'

/**
 * Lisans (son kullanıcı) adresi kaydedilirken ADD mi UPDATE mi çağrılacağına karar verir.
 *
 * NEDEN GEREKLİ: Backend `AddressService.Add`, adresi (Musteri + AdresAdi) çiftinde tekil
 * kabul ediyor — aynı başlıkla ikinci kayıt "Aynı adres başlığı daha önce kullanılmıştır"
 * hatasıyla reddediliyor. Modal önceden koşulsuz ADD çağırdığı için, kayıtlı bir lisans
 * adresi üzerinde yapılan hiçbir değişiklik (Reseller dahil) TableAddress'e yazılmıyordu.
 *
 * SAP'ten gelen adresler (Issap) güncellenemez — backend `Update` onları reddediyor —
 * bu yüzden eşleşme adayı olarak değerlendirilmezler.
 *
 * @returns Güncellenecek kayıtlı adres, ya da yeni kayıt açılacaksa undefined.
 */
export const findSavedLicenseAddress = (
  licenseAddressList: IAddressModel[] | undefined | null,
  addressTitle: string | undefined | null
): IAddressModel | undefined => {
  const title = (addressTitle ?? '').trim()
  if (!title) return undefined

  return (licenseAddressList ?? []).find(
    address => !address.Issap && (address.AddressTitle ?? '').trim() === title
  )
}
